import { useEffect, useRef, useState } from 'react';

type UseAnimatedIncrementedValueProps = {
  from: number;
  to: number;
  duration?: number;
};

export const useAnimatedIncrementedValue = ({ from, to, duration = 300 }: UseAnimatedIncrementedValueProps) => {
  const [value, setValue] = useState<number>(from);
  const refValue = useRef(from);

  useEffect(() => {
    let startTimestamp: number | undefined;
    const animate = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;

      const progress = Math.min(1, (timestamp - startTimestamp) / duration);
      const interpolatedValue = refValue.current + (to - refValue.current) * progress;

      refValue.current = interpolatedValue;
      setValue(interpolatedValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);

    return () => {
      startTimestamp = undefined;
    };
  }, [duration, from, to]);

  return Math.round(value);
};
